<div class="thumbnail-container">
  <iframe *ngIf="securedUrl" id="video1" width="100%" height="100%;" [src]="securedUrl" frameborder="0" webkitallowfullscreen
          mozallowfullscreen>
  </iframe>
</div>
